"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swapArrayLocs = void 0;
const swapArrayLocs = (items, firstIndex, secondIndex) => {
    const results = items.slice();
    const firstItem = items[firstIndex];
    results[firstIndex] = items[secondIndex];
    results[secondIndex] = firstItem;
    return results;
};
exports.swapArrayLocs = swapArrayLocs;
